import { render, staticRenderFns } from "./TableRiskAppraisal2_5x4.vue?vue&type=template&id=40f0420e&scoped=true"
import script from "./TableRiskAppraisal2_5x4.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal2_5x4.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal2_5x4.vue?vue&type=style&index=0&id=40f0420e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f0420e",
  null
  
)

export default component.exports